import React from "react"
import { graphql } from "gatsby"

import Layout from "§/src/components/layout"
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import "./_style.scss"

import Error from "§/src/components/error"
import { isEmpty } from "lodash"
import SEO from "§/src/components/seo"
import { useTranslation } from "react-i18next"

// Components
import VideoFull from "§/src/components/sections/video-full"
import ImageText from "§/src/components/sections/image-text"
import Rules from "§/src/components/sections/rules"

export function Head(props) {
  const data = props.pageContext.data || {}
  const seo = data.seo || {}

  return (
    <React.Fragment>
      <html lang={process.env.GATSBY_SITE_LANG.replace(/_/g, "-")}></html>
      <body className="venezia-con-rivo"></body>
      <SEO seo={seo} lang={props?.data?.lang}/>
    </React.Fragment>
  )
}

const VeneziaConRivo = props => {

    const { t } = useTranslation()

    const data = props?.pageContext || {}

    const language = props?.data?.lang?.locale?.locale

    const hero = {
      title: data?.acfPages_veneziaConRivo?.titoloHero,
      image: data?.acfPages_veneziaConRivo?.thumbnailVideoHero?.gatsbyImage1920,
      imageMobile: data?.acfPages_veneziaConRivo?.thumbnailVideoHeroMobile?.gatsbyImage992,
      videoYt: data?.acfPages_veneziaConRivo?.videoHero,
      enableContent: true,
      type: 'bg-loop',
      titleTag: 'h1',
    };

    const intro  = {
      titolo: data?.acfPages_veneziaConRivo?.contenutoIntro,
      testo: data?.acfPages_veneziaConRivo?.contenutoIntro2,
      image: data?.acfPages_veneziaConRivo?.immagineIntro?.gatsbyImage992,
      classeTitolo: "intro-title",
      classeTesto: "intro-content h2",
      reverse: true
    };

    const rulesWithIntro  = {
      titolo: data?.acfPages_veneziaConRivo?.titoloRegoleintro,
      testo: data?.acfPages_veneziaConRivo?.contenutoRegoleintro,
      image: data?.acfPages_veneziaConRivo?.immagineRegoleintro?.gatsbyImage992,
      rules: data?.acfPages_veneziaConRivo?.regole,
      rulesOffset: 0,
      hasIntro: true,
      reverse: true
    };

    const rule4 = {
        titolo: data?.acfPages_veneziaConRivo?.regole[3]?.titoloRegola,
        testo: data?.acfPages_veneziaConRivo?.regole[3]?.contenutoRegola,
        image: data?.acfPages_veneziaConRivo?.immagineRegola4?.gatsbyImage992,
        classeTitolo: "intro-title",
        classeTesto: "intro-content",
        reverse: true
    }

    const rulesSecondSet  = {
      rules: data?.acfPages_veneziaConRivo?.regole,
      rulesOffset: 4,
      hasIntro: false,
    };

    const rulesThirdSet  = {
      rules: data?.acfPages_veneziaConRivo?.regole,
      rulesOffset: 7,
      hasIntro: false,
    };

    const rule11 = {
        titolo: data?.acfPages_veneziaConRivo?.regole[10]?.titoloRegola,
        testo: data?.acfPages_veneziaConRivo?.regole[10]?.contenutoRegola,
        image: data?.acfPages_veneziaConRivo?.immagineRegola11?.gatsbyImage992,
        classeTitolo: "rule-title",
        classeTesto: "rule-content",
        background: data?.acfPages_veneziaConRivo?.backgroundRegola11?.gatsbyImage1920
    }

    return (
        <Layout lang={["venezia-con-rivo"]} container="full" className="nobg-header" lang={props?.data?.lang}>
            {!isEmpty(data) ? (
                <React.Fragment>

                    <VideoFull data={hero} className="noheader overlayoff" />

                    <ImageText data={intro} className="intro"/>

                    <Rules data={rulesWithIntro} className="rules rules-intro"/>

                    <section className="rule-4">
                          <div className='container d-flex align-items-center flex-column flex-md-row'>
                            <div className="waves">
                                <div></div>
                            </div>
                            <div className='col image'>
                              {rule4.image && (
                                  <GatsbyImage
                                    className="sw-image"
                                    image={getImage(rule4.image)}
                                    objectFit="cover"
                                    fit="cover"
                                    alt={rule4.image?.altText || 'rule-4 image'}
                                  />
                              )}
                            </div>
                            <div className='col text'>
                              {rule4.titolo && (
                                <>
                                    <h2 className={rule4.classeTitolo}>4.</h2>
                                    <h2 className={rule4.classeTitolo}>{rule4.titolo}</h2>
                                </>
                              )}
                              {rule4.testo && (
                                <p className={rule4.classeTesto}>{rule4.testo}</p>
                              )}
                            </div>
                        </div>
                    </section>

                    <Rules data={rulesSecondSet} className="rules rules-intro"/>

                    <Rules data={rulesThirdSet} className="rules rules-intro"/>

                    <section className="rule-11 image-text">
                          <div className='container d-flex align-items-center flex-column flex-md-row position-relative'>
                            <div className="waves">
                                <div></div>
                            </div>
                            <figure className='background position-absolute'>
                                <GatsbyImage
                                    className="bg-image"
                                    image={getImage(rule11.background)}
                                    objectFit="cover"
                                    fit="cover"
                                    alt={rule11.background?.altText || 'image-text background'}
                                />
                            </figure>
                            <div className='col image'>
                              {rule11.image && (
                                  <GatsbyImage
                                    className="sw-image"
                                    image={getImage(rule11.image)}
                                    objectFit="cover"
                                    fit="cover"
                                    alt={rule11.image?.altText || 'rule-4 image'}
                                  />
                              )}
                            </div>
                            <div className='col text'>
                              {rule11.titolo && (
                                <>
                                    <h2 className={rule11.classeTitolo}>11.</h2>
                                    <h2 className={rule11.classeTitolo}>{rule11.titolo}</h2>
                                </>
                              )}
                              {rule11.testo && (
                                <p className={rule11.classeTesto}>{rule11.testo}</p>
                              )}
                            </div>
                        </div>
                    </section>

                </React.Fragment>
            ) : (
                <Error message="Something Went Wrong" />
            )}
        </Layout>
    )
}

export default VeneziaConRivo

export const pageQuery = graphql`
  query GET_TRANSLATIONS($databaseId: Int!) {
    lang: wpPage(databaseId: { eq: $databaseId }) {
      locale {
        locale
      }
      translations {
        href
        locale
      }
      title
      uri
    }
  }
`
